export const isImage = (fileName) => {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    return imageExtensions.some((ext) => fileName.toLowerCase().endsWith(ext));
};
